module.exports = __webpack_public_path__ + "img/3314375.7420846a.jpg";